import { i18nFilter } from "app/filters/i18nFilter";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";
import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { isPaidExcelAllowed } from "app/services/PaidExcelService/isPaidExcelAllowed";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { formatDate } from "@similarweb/pro-logic-components";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import type { IncludeExcludeKeywords } from "app/pages/digital-marketing/brand-monitoring-campaigns/shared/useBPRequestBody";


const RankingsDistributionTitleContainer = styled(FlexRow)`
    height: 64px;
    justify-content: space-between;
    align-items: center;
    padding-left: 24px;
    padding-right: 8px;
`;

const DateIndicator = styled.span`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])}
`;

interface IRankingDistributionTableTitleContainer {
    duration: string;
    excelLink: string;
    totalCount: number;
    requestBody: IncludeExcludeKeywords[];
}

export const RankingDistributionTableTitleContainer: FC<IRankingDistributionTableTitleContainer> = (props) => {
    const { duration, excelLink, totalCount, requestBody } = props;
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;

    const trackExcelDownload = () => {
        allTrackers.dispatchTrackEvent("Download", "submit-ok", "Table/Excel");
    };
    const dateFilter = useSubtitleFilters("date");
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const FormattedDate = formatDate(dateFilter[0]?.value?.from, dateFilter[0]?.value?.to);

    return (
        <RankingsDistributionTitleContainer>
            <DateIndicator>
                {i18nFilter()("rankings_distribution.tabletop.date", {
                    date: FormattedDate,
                })}
            </DateIndicator>
            <DownloadButtonMenu
                Excel={true}
                downloadUrl={excelLink}
                excelBodyForReq={requestBody}
                exportFunction={trackExcelDownload}
                excelLocked={!downloadExcelPermitted}
                PaidExcel={isPaidExcelAllowed()}
                totalCount={totalCount}
            />
        </RankingsDistributionTitleContainer>
    );
};
